import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query viLabels ($id: ID!) {
      viLabels: FilmMaster (id: $id) {
        id
        ViLabels {
          ...viLabelDetail
        }
      }
    }
    ${fragments.viLabelDetail}
    ${fragments.kgraphDetail}
    ${fragments.viLabelProps}
  `
